import React, { useEffect, useRef } from 'react';
import styles from './Me.module.css';
import hilaPhoto from "../../images/הילה קוסייב מי אני.png"; 
import ScrollReveal from 'scrollreveal';


const AboutMe = () => {
  const containerRef = useRef(null);

  // ScrollReveal configuration
  useEffect(() => {
    if (containerRef.current) {
      const sr = ScrollReveal({
        duration: 1000,
        delay: 150,
        opacity: 0,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        container: window.document.documentElement,
        mobile: true,
        reset: false,
        viewFactor: 0.2
      });

      sr.reveal(`.${styles.revealItem}`, { 
        origin: 'bottom',
        distance: '20px',
        interval: 100
      });
    }

    return () => {
      if (ScrollReveal().isInitialized) { 
        ScrollReveal().destroy();
      }
    };
  }, []);

  // Handle WhatsApp button click
  const handleWhatsAppClick = () => {
    const phoneNumber = '972558865332'; // מספר בפורמט בינלאומי ללא + ומקפים
    const message = 'היי הילה הגעתי מהדף שלך, אשמח לשמוע עוד על..';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      <section ref={containerRef} className={styles.section} id="מי-אני">
        <div className={styles.container}>
          <div className={`${styles.imageWrapper} ${styles.revealItem}`}>
            <img src={hilaPhoto} alt="הילה קוסייב" className={styles.image} /> 
          </div>

          <div className={`${styles.content} ${styles.revealItem}`}>
            <h2 className={styles.mainTitle}>נעים להכיר, הילה קוסייב</h2>

            <div className={styles.quoteContainer}>  
              <p className={styles.quote}>  
                "שיווק טוב הוא לא מזל. יש נוסחה."  
              </p>  
            </div>  

            <div className={styles.textBlock}>  
              <p className={styles.paragraph}>  
                האמת? זה לא התחיל משיווק. זה התחיל מסקרנות - לראות איך רעיון הופך למציאות על המסך. <strong>אבל אז שמתי לב לתופעה:</strong> הסרטונים שלא היו רק "יפים", אלא <strong>מדויקים במסר</strong> - הביאו פניות, לידים ומכירות אמיתיות.
              </p>  

              <div className={styles.divider}></div>  

              <p className={styles.paragraph}>  
                רובם חשבו שהם צריכים לעמוד מול מצלמה עם תסריטים קשיחים ופאנצ'ים שנשמעים כמו כולם. <strong>אבל האמת?</strong> לקוחות מתחברים למי שאת באמת - לא לגרסה שאת מנסה לשחק.
              </p>  

              <div className={styles.divider}></div>  

              <p className={styles.paragraph}>  
                לכן בתהליך שלנו אנחנו מפצחות את המסרים בשלב האסטרטגיה, מזקקות את מה שמייחד את העסק שלך, וכשמגיע יום הצילום - <strong>את לא מקריאה טקסט. את מדברת את האמת שלך</strong> בצורה שמורגשת.
              </p>  

              <div className={styles.divider}></div>  

              <p className={styles.finalText}>  
                כשהמסר מדויק והתוכן מרגיש אמיתי? החשיפות מגיעות. לפעמים בגדול - למאות אלפים ומיליוני צפיות. אבל החשיפות הן רק הבונוס. מה שבאמת חשוב? לידים שמתחממים, ולקוחות שאומרים: "הילה, מכרתי בזכות התוכן שלנו." וזה הרגע שבו מצלמה הופכת מ"עוד מטלה שיווקית" - לנכס שמייצר כסף לעסק שלך.
              </p>  
            </div>  

            <button  
              className={styles.ctaButton}  
              onClick={handleWhatsAppClick}  
            >  
              <span className={styles.buttonIcon}>💬</span>  
              המסע שלנו מתחיל בלחיצה כאן  
            </button>  
          </div>  
        </div>  
      </section>
    </>
  );
};

export default AboutMe;